import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { ProductContext } from '../types/productContext';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private readonly activeProduct$: ReplaySubject<string> = new ReplaySubject<string>();
  public readonly currentProduct$: Observable<string> = this.activeProduct$.asObservable();

  private readonly enabledProducts$: BehaviorSubject<ProductContext[]> = new BehaviorSubject<ProductContext[]>([]);
  public readonly availableProducts$: Observable<ProductContext[]> = this.enabledProducts$.asObservable();

  private readonly activeTopic$: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null); // Use BehaviorSubject
  public readonly currentTopic$: Observable<string | null> = this.activeTopic$.asObservable();

  private readonly enabledTopics$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public readonly availableTopics$: Observable<string[]> = this.enabledTopics$.asObservable();

  setActiveProduct(productName: string): void {
    this.activeProduct$.next(productName);
  }

  updateEnabledProducts(products: ProductContext[]): void {
    this.enabledProducts$.next(products);
  }

  setActiveTopic(topicName: string): void {
    this.activeTopic$.next(topicName);
  }

  updateEnabledTopics(topics: string[]): void {
    this.enabledTopics$.next(topics);
  }
}
